(() => {
    class Favorites extends App.Entities.Endpoint {
        constructor() {
            super('accounts.favorites');
            this.cache = false;
            App.Observer.register(this);
        }
        get get() {
            // only call for result if user is logged in
            return (async() => App.Variable('userId') ? await super.get : [])();
        }

        async getByProduct(product) {
            const items = await this.get;
            return items.find(element => element.product == product);
        }
    }
    App.Endpoint.Favorites = new Favorites();
})();
